<template>
  <div class="container-fluid py-4">
    <!-- Header moderne -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-clinique">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-pencil-square fs-2 text-primary"></i>
        <h2 class="fw-bold mb-0">Modification d'un Utilisateur</h2>
      </div>
      <router-link class="btn btn-primary btn-lg shadow-sm btn-clinique" :to="{ name: 'utilisateur' }">
        <i class="bi bi-arrow-left-circle me-2"></i> Retour
      </router-link>
    </div>

    <!-- Card formulaire -->
    <div class="card p-4 shadow-sm rounded card-clinique">
      <div class="row g-4">
        <!-- Nom -->
        <div class="col-md-6">
          <label for="nom" class="form-label fw-semibold">Nom</label>
          <input type="text" id="nom" v-model="user.nom" class="form-control form-control-clinique" :class="{ 'is-invalid': error.nom }" placeholder="Nom">
          <div class="invalid-feedback">{{ error.nom }}</div>
        </div>

        <!-- Prénom -->
        <div class="col-md-6">
          <label for="prenom" class="form-label fw-semibold">Prénom</label>
          <input type="text" id="prenom" v-model="user.prenom" class="form-control form-control-clinique" :class="{ 'is-invalid': error.prenom }" placeholder="Prénom">
          <div class="invalid-feedback">{{ error.prenom }}</div>
        </div>

        <!-- Nom utilisateur -->
        <div class="col-md-6">
          <label for="username" class="form-label fw-semibold">Nom utilisateur</label>
          <input type="text" id="username" v-model="user.username" class="form-control form-control-clinique" :class="{ 'is-invalid': error.username }" placeholder="Nom d'utilisateur">
          <div class="invalid-feedback">{{ error.username }}</div>
        </div>

        <!-- Email -->
        <div class="col-md-6">
          <label for="email" class="form-label fw-semibold">Email</label>
          <input type="email" id="email" v-model="user.email" class="form-control form-control-clinique" :class="{ 'is-invalid': error.email }" placeholder="Email">
          <div class="invalid-feedback">{{ error.email }}</div>
        </div>

        <!-- Type utilisateur -->
        <div class="col-md-6">
          <label for="typeUser" class="form-label fw-semibold">Type d'utilisateur</label>
          <select id="typeUser" v-model="user.typeUser" class="form-select form-select-clinique" :class="{ 'is-invalid': error.type }">
            <option value="" disabled>-- Sélectionnez un type --</option>
            <option v-for="type in typesUser.filter(t => t.nom !== 'Super Admin')" :key="type.id" :value="type.id">{{ type.nom }}</option>
          </select>
          <div class="invalid-feedback">{{ error.type }}</div>
        </div>

        <!-- Activé ? -->
        <div class="col-md-6 d-flex align-items-center mt-3">
          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" id="enabled" v-model="user.enabled">
            <label class="form-check-label ms-2 fw-semibold" for="enabled">Activé ?</label>
          </div>
        </div>
      </div>

      <!-- Boutons -->
      <div class="d-flex justify-content-end gap-3 mt-4">
        <button class="btn btn-light border shadow-sm px-4 py-2" @click="cancel">
          <i class="bi bi-x-circle me-1"></i> Annuler
        </button>
        <button class="btn btn-success shadow px-4 py-2 btn-clinique" :disabled="isLoading" @click="updateUser">
          <i class="bi bi-save me-1"></i>
          <span v-if="isLoading">Mise à jour...</span>
          <span v-else>Mettre à jour</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';

export default {
  data() {
    return {
      isLoading: false,
      user: {
        id: null,
        nom: '',
        prenom: '',
        username: '',
        email: '',
        enabled: true,
        typeUser: null
      },
      error: { nom: '', prenom: '', username: '', email: '', type: '' },
      typesUser: []
    };
  },
  methods: {
    async getTypeUser() {
      try {
        const response = await api.getItems('type_users');
        this.typesUser = response.data.data;
      } catch (error) {
        console.error("Erreur récupération types d'utilisateurs", error);
      }
    },
    async loadUser() {
      try {
        const userId = this.$route.params.id;
        const response = await api.getItem('users', userId);
        this.user = response.data;
        this.user.typeUser = this.user.typeUser ? this.user.typeUser.id : null;
      } catch (error) {
        console.error("Erreur lors du chargement de l'utilisateur", error);
      }
    },
    validateForm() {
      this.error = {
        nom: this.user.nom ? '' : 'Le nom est requis',
        prenom: this.user.prenom ? '' : 'Le prénom est requis',
        username: this.user.username ? '' : 'Le nom d\'utilisateur est requis',
        email: this.user.email ? '' : 'L\'email est requis',
        type: this.user.typeUser ? '' : 'Le type d\'utilisateur est requis'
      };
      return !Object.values(this.error).some(err => err !== '');
    },
    async updateUser() {
      if (!this.validateForm() || this.isLoading) return;
      try {
        this.isLoading = true;
        await api.updateItem('users', this.user.id, this.user);
        alert("Utilisateur mis à jour avec succès !");
        this.$router.push({ name: 'utilisateur' });
      } catch (error) {
        console.error("Erreur lors de la mise à jour de l'utilisateur", error);
      } finally {
        this.isLoading = false;
      }
    },
    cancel() {
      this.$router.push({ name: 'utilisateur' });
    }
  },
  created() {
    this.getTypeUser();
    this.loadUser();
  }
};
</script>

<style scoped>
/* --- Header clinique --- */
.header-clinique {
  padding: 15px 20px;
  background-color: #e9f5ff;
  border-radius: 12px;
  margin-bottom: 20px;
}

/* --- Card formulaire --- */
.card-clinique {
  background: #f8fafd;
  border-radius: 12px;
  border: none;
}

/* --- Champs --- */
.form-control-clinique,
.form-select-clinique {
  border-radius: 10px;
  border: 1px solid #d1e3f0;
  padding: 10px 14px;
  transition: all 0.3s ease;
}
.form-control-clinique:focus,
.form-select-clinique:focus {
  box-shadow: 0 0 6px #0d6efd33;
  border-color: #0d6efd;
}

/* --- Boutons --- */
.btn-clinique {
  background: linear-gradient(90deg, #0d6efd, #6610f2);
  border: none;
  color: #fff;
  border-radius: 10px;
  transition: all 0.3s ease;
}
.btn-clinique:hover {
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
  transform: translateY(-2px);
}
</style>
